import { Link } from "react-router-dom";
import { ArrowLeft } from "@phosphor-icons/react";
import PageHero from "@/components/layout/PageHero";

const NotFound = () => (
  <>
    <PageHero
      eyebrow="Erro 404"
      title="Página não encontrada"
      description="O endereço que você tentou acessar não existe ou foi movido."
    />
    <section className="section-padding bg-white text-center">
      <div className="container-custom">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#E73336] text-white font-bold text-sm uppercase tracking-wide rounded-full hover:bg-[#BD2A2C] transition-all btn-cta"
        >
          <ArrowLeft size={18} />
          Voltar para o início
        </Link>
      </div>
    </section>
  </>
);

export default NotFound;
